import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/banners/left-menu-banner.jpg")